import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
// import GridContainer from "components/Grid/GridContainer.js";
// import GridItem from "components/Grid/GridItem.js";
// import CardBody from "components/Card/CardBody.js";
// import CardHeader from "components/Card/CardHeader.js";
// import Parallax from "components/Parallax/Parallax.js";

import styles from "assets/jss/material-kit-react/views/loginPage.js";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(styles);



export default function ErrorPageInside(props) {
    
    const classes = useStyles();
    const { t } = useTranslation();

    return(
        <div className="paddingLeft64 maxWidth800 paddingBottom120">
            <div className="semibold-h200 cl-secondary-400 paddingBottom24">{t("ErrorPage_title")}</div>
            <div className="semibold-h400 cl-secondary-100 paddingBottom32">{t("ErrorPage_description")}</div>
            <a className='displayInlineBlock cl-secondary-100 semibold-b300 myIeseButton paddingTop16 paddingBottom16 marginRight24' onClick={()=>{window.open('https://alumni.iese.edu/page/qa-y-ayuda', '_self')}}>{t("ErrorPage_actionhelp")}</a>
            <a className='displayInlineBlock cl-secondary-100 semibold-b300 myIeseButton paddingTop16 paddingBottom16 marginTop12' onClick={()=>{window.open('https://alumni.iese.edu/', '_self')}}>{t("ErrorPage_action")}</a>
            {/* <Parallax small image={require("assets/img/principal.jpg")} /> */}
            {/* <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={8}>
                    <form className={classes.form} style={{borderRadius: "8px"}}>
                        <CardHeader>
                            <div style={{width: "20px"}}></div>
                        </CardHeader>
                        <CardBody>
                            <GridContainer  justify = "center">
                                <GridItem xs={11} sm={11} md={11}>
                                    <div>
                                        <img src={require('assets/img/error.png')} style={{maxWidth: "160px", width: "100%", display: "block",  marginLeft: "auto",  marginRight: "auto"}} />
                                        <h2 className={classes.defaultFont} style={{textAlign: "center"}}>{t("PaymentError")}</h2>
                                        <h3 className={classes.defaultFont} style={{textAlign: "center"}}>{t("PaymentErrorSubtitle")} </h3>
                                    </div>
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                    </form>
                </GridItem>
            </GridContainer> */}
        </div>
    );
}